import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import MuPb from "../../../widgets/MuPb";
import CommonItemCard from "../../../widgets/CommonItemCard";
import BackBtn from "../../../widgets/BackBtn";
import useApiEp from "../../../hooks/useApiEp";

const MyStallViewers = () => {
  const { isLoading, isError, error, data } = useApiEp(`/user/stall-viewers?`);

  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <div>Error: {error.message}</div>; // Display error message if there is an error
  }

  return (
    <Box mt={1} ml={2}>
      <BackBtn />
      <Typography variant="h6" gutterBottom>
        People who viewed your stall
      </Typography>
      <Box ml={1} mt={4}>
        <Grid container spacing={2}>
          {data.map((user, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <CommonItemCard item={user?.user_info} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default MyStallViewers;
